import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class AboutHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
            image:encodeURI(this.props.content[1].image)
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }
         
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

        <div class="choseus-area about-area bg-theme ">
        <div class="container-full">
            <div class="row">
                <div class="content-box">
                    <div class="col-md-6 thumb bg-cover" style={{backgroundImage: `url(${this.state.image})`}}   ></div>
                    <div class="col-md-6 info">
                        <h4 className="colorwhite">{this.state.content[1]['title']}</h4>
                        <h2  className="colorwhite">{this.state.content[1]['subtitle']}</h2> 
                    <div className="colorwhite" dangerouslySetInnerHTML={{ __html: this.state.content[1].description }} />    
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>  
       
    );
}

}

export default AboutHome;